//#region src/variants/variants_button_group.js
var variants_button_group_default = { default: {
	props: { alignment: { initialValue: "start" } },
	slots: { default: { initialValue: "<dt-button importance=\"primary\">Confirm</dt-button><dt-button importance=\"outlined\">Cancel</dt-button>" } }
} };
//#endregion
export { variants_button_group_default as default };

//# sourceMappingURL=variants_button_group.js.map